import api from './axiosConfig';

export interface QAProcessorCall {
  id: number;
  callid: string;
  // eslint-disable-next-line
  status: 'pending' | 'transcribing' | 'summarizing' | 'analyzing' | 'completed' | 'error';
  retrycount: number;
  createdat: Date;
  errormessage?: string;
  transcriptionstarttime?: Date;
  transcriptionendtime?: Date;
  summarizationstarttime?: Date;
  summarizationendtime?: Date;
  analysisstarttime?: Date;
  analysisendtime?: Date;
}

export interface QAProcessorConfig {
  id: number;
  active: boolean;
  transcriptionMainProvider: string;
  transcriptionFallbackProvider: string;
  analysisMainProvider: string;
  analysisFallbackProvider: string;
  maxConcurrentProcesses: number;
  lastProcessedDate: string | null;
}

export interface UpdateQAProcessorConfigRequest {
  active: boolean;
  lastProcessedDate: string | null;
  maxConcurrentProcesses: number;
  transcriptionMainProvider: string;
  transcriptionFallbackProvider: string;
  analysisMainProvider: string;
  analysisFallbackProvider: string;
}

interface DateRange {
  datefrom: string;
  dateto: string;
}

export const getProcessorStatus = async (
  dateRange: DateRange
): Promise<QAProcessorCall[]> => {
  try {
    const response = await api.post('/qaprocessoractivtylog', dateRange);
    return response.data;
  } catch (error) {
    console.error('Error fetching QA processor status:', error);
    throw error;
  }
};

export const getProcessorConfig = async (): Promise<QAProcessorConfig> => {
  try {
    const response = await api.get('/qaprocessorconfig');
    return response.data;
  } catch (error) {
    console.error('Error fetching QA processor config:', error);
    throw error;
  }
};

export const updateProcessorConfig = async (
  config: UpdateQAProcessorConfigRequest
): Promise<QAProcessorConfig> => {
  try {
    const response = await api.put('/qaprocessorconfig', config);
    return response.data.config;
  } catch (error) {
    console.error('Error updating QA processor config:', error);
    throw error;
  }
};
